// extracted by mini-css-extract-plugin
export default {"footer_block":"Footer_footer_block__YIJ-s","column":"Footer_column__odJcZ","title":"Footer_title__GhqH5","adress_tel":"Footer_adress_tel__thfNb"};